import { createGeneralSelectors } from '../_common/selectors';
import { createSelector } from 'reselect';

const getToxProfileItemSlice = state => state.toxProfileItem;
export const { getById, getIds, makeGetByQuery } = createGeneralSelectors(getToxProfileItemSlice);

export const getToxProfileItemList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
